const currentBankAccountReducer = (bank_account = "", action) => {
    switch (action.type) {
        case "ADD_CURRENT_BANK_ACCOUNT":
            return action.payload;
        default:
            return bank_account;
    }
};

export default currentBankAccountReducer;